import ContractSelect from '@/components/DropdownSelect/Contract';
import HeadTeacherSelect from '@/components/DropdownSelect/HeadTeacher';
import CustomDatePicker from '@/components/FormItems/DatePicker';
import { getById as getCourseById } from '@/pages/Course/service';
import AttributeSelect from '@/pages/Lesson/components/AttributeSelect';
import RawDurationView from '@/pages/Lesson/components/RawDurationView';
import { create, update } from '@/pages/Lesson/service';
import {
  getAdjustedProductUsage,
  getAttrUsage,
  getContractUsablePoints,
} from '@/utils/AttributeExchange';
import { getErrorMessageFromResponse } from '@/utils/utils';
import { isAppealCourse } from '@/utils/Appeal';
import {
  ProForm,
  ProFormDateTimePicker,
  ProFormDependency,
  ProFormDigit,
  ProFormGroup,
  ProFormRadio,
  ProFormSelect,
  ProFormText,
  ProFormCheckbox,
} from '@ant-design/pro-components';
import { Form, Spin, message, Alert, Tag, Select, Radio, Space, Checkbox } from 'antd';
import dayjs from '@/utils/dayjs';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useModel } from 'umi';
import {
  getContractById,
  getLessonCount,
  checkConflictLesson,
  getGradingSchemeByCourse,
  getAppealServiceProcess,
} from './service';
import { query } from '@/pages/Course/service';
import { calcAmountAvailable, timeChangeDisabled, wordChangeDisabled } from './utils';
import { isDstDate } from '../Global/service';
import { cn } from '@h6you/timezone-names-cn';
import FileUpload from '@/pages/Contract/components/Uploads';
import { larkApprovalForContractReplacement } from '@/pages/Contract/service';
import { AppMap } from '@/utils/lark';
import LessonNameInput from './LessonNameInput';
import { getInterviews, getSimilarScheduledLessons } from '@/pages/Lesson/service';
import { useDebounceStateWithPending } from '../DebounceStateWithPending/DebounceStateWithPending';
import { checkConflictFirstLessonCommunication } from '@/services/EducationalResearchTasks';
import { getByLesson } from '@/pages/CourseMatch/service';
const { Option } = Select;

const resetFields = [
  'course',
  'productService',
  'name',
  'topic',
  'teachers',
  'assessmentId',
  'zoomRequired',
  'zoomLink',
];
const zoomDefaultOptions = [
  {
    label: '自动创建',
    value: 'yes',
  },
  {
    label: '不需要直播间',
    value: 'no',
  },
];

const zoomDefaultOptionsForBanKe = [
  {
    label: '会议室(Meeting)',
    value: 'meeting',
  },
  {
    label: '在线研讨会(Webinar)',
    value: 'webinar',
  },
];

const repeatedScheduleOptions = [
  {
    label: '天',
    value: 'days',
  },
  {
    label: '周',
    value: 'weeks',
  },
];

const CreateForm = ({ onFinish, courseId, studentId, initialValues = {} }) => {
  const {
    initialState: { currentUser, permissions },
  } = useModel('@@initialState');
  const formRef = useRef();
  const submitRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const [currentContract, setCurrentContract] = useState(initialValues.contract);
  const [contractData, setContractData] = useState();
  // courseData 是班课的数据
  const [courseData, setCourseData] = useState();
  const [courseLoading, setCourseLoading] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState();
  const [lessonParent, setLessonParent] = useState();
  //查看有没有未完成的首课课前沟通
  const [hasUnfinishedFirstLessonCommunication, setHasUnfinishedFirstLessonCommunication] =
    useState(false);
  const [zoomOptions, setZoomOptions] = useState([]);
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [gradingAssessmentOptions, setGradingAssessmentOptions] = useState([]);
  const [gradingAssessmentLoading, setGradingAssessmentLoading] = useState(false);
  const gradingFetchIdRef = useRef(0);
  const lastGradingFetchParamsRef = useRef({ courseId: null, studentId: null });
  const gradingWarningShownRef = useRef(false);

  const resolvedStudentId = useMemo(() => {
    if (studentId) {
      return studentId;
    }
    if (contractData?.student?.id) {
      return contractData.student.id;
    }
    return undefined;
  }, [studentId, contractData?.student?.id]);

  const flattenAssessments = useCallback((items, parentLabel = '') => {
    if (!Array.isArray(items)) {
      return [];
    }
    return items.reduce((acc, item) => {
      if (!item) {
        return acc;
      }
      const label =
        parentLabel && parentLabel.length
          ? `${parentLabel} / ${item.name || '未命名评估'}`
          : item.name || '未命名评估';
      const hasChildren = Array.isArray(item.children) && item.children.length > 0;
      if (!hasChildren) {
        acc.push({
          value: item.id,
          label,
        });
      }
      if (hasChildren) {
        acc.push(...flattenAssessments(item.children, label));
      }
      return acc;
    }, []);
  }, []);

  const refreshGradingAssessments = useCallback(
    async ({ resetValue = true } = {}) => {
      if (!formRef.current) {
        return;
      }
      const courseValueFromForm = formRef.current?.getFieldValue('course');
      const resolvedCourseId =
        courseValueFromForm ||
        courseId ||
        initialValues?.course ||
        initialValues?.courseId ||
        courseData?.id;

      if (!resolvedStudentId || !resolvedCourseId) {
        setGradingAssessmentOptions([]);
        gradingWarningShownRef.current = false;
        if (resetValue) {
          formRef.current?.setFieldsValue?.({
            assessmentId: undefined,
          });
        }
        lastGradingFetchParamsRef.current = {
          courseId: null,
          studentId: null,
        };
        return;
      }

      if (
        lastGradingFetchParamsRef.current.courseId === resolvedCourseId &&
        lastGradingFetchParamsRef.current.studentId === resolvedStudentId
      ) {
        return;
      }

      lastGradingFetchParamsRef.current = {
        courseId: resolvedCourseId,
        studentId: resolvedStudentId,
      };

      gradingFetchIdRef.current += 1;
      const requestId = gradingFetchIdRef.current;
      setGradingAssessmentLoading(true);
      try {
        const scheme = await getGradingSchemeByCourse({
          studentId: resolvedStudentId,
          courseId: resolvedCourseId,
        });
        if (requestId !== gradingFetchIdRef.current) {
          return;
        }
        const assessments = Array.isArray(scheme?.assessments) ? scheme.assessments : [];
        if (!assessments.length) {
          setGradingAssessmentOptions([]);
          if (resetValue) {
            formRef.current?.setFieldsValue?.({ assessmentId: undefined });
          } else {
            const currentValue = formRef.current?.getFieldValue?.('assessmentId');
            if (currentValue !== undefined) {
              formRef.current?.setFieldsValue?.({ assessmentId: undefined });
            }
          }
          if (!gradingWarningShownRef.current) {
            message.warning('未找到评分标准，请先创建评分标准');
            gradingWarningShownRef.current = true;
          }
          lastGradingFetchParamsRef.current = {
            courseId: null,
            studentId: null,
          };
          return;
        }

        gradingWarningShownRef.current = false;
        const options = flattenAssessments(assessments);
        setGradingAssessmentOptions(options);

        const currentValue = formRef.current?.getFieldValue?.('assessmentId');
        const hasCurrent =
          currentValue !== undefined &&
          currentValue !== null &&
          options.some((opt) => String(opt.value) === String(currentValue));

        if (!hasCurrent) {
          formRef.current?.setFieldsValue?.({
            assessmentId: resetValue && options.length === 1 ? options[0].value : undefined,
          });
        }
      } catch (error) {
        if (requestId !== gradingFetchIdRef.current) {
          return;
        }
        setGradingAssessmentOptions([]);
        if (!gradingWarningShownRef.current) {
          message.error(getErrorMessageFromResponse(error) || '获取评分标准失败');
          gradingWarningShownRef.current = true;
        }
        if (resetValue) {
          formRef.current?.setFieldsValue?.({ assessmentId: undefined });
        }
        lastGradingFetchParamsRef.current = {
          courseId: null,
          studentId: null,
        };
      } finally {
        if (requestId === gradingFetchIdRef.current) {
          setGradingAssessmentLoading(false);
        }
      }
    },
    [
      courseData?.id,
      courseId,
      flattenAssessments,
      initialValues?.course,
      initialValues?.courseId,
      resolvedStudentId,
    ],
  );
  //默认为学生的时区
  const [timezone, setTimezone] = useState(
    initialValues && initialValues.studentTimeZone
      ? initialValues.studentTimeZone
      : Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  const [potentialConflictLessons, setPotentialConflictLessons, potentialConflictLessonsPending] =
    useDebounceStateWithPending({}, checkConflictLesson);

  const [potentialInterviews, setPotentialInterviews, potentialPending] =
    useDebounceStateWithPending([], getInterviews, 1000);

  const [
    potentialConflictCommunication,
    setPotentialConflictCommunication,
    potentialConflictCommunicationPending,
  ] = useDebounceStateWithPending({}, checkConflictFirstLessonCommunication);

  const [dstDatesDisplay, setDstDatesDisplay] = useState([]);

  const [recordCourse, setRecordCourse] = useState([]);

  const [uploading, setUploading] = useState(false);

  const [isPolishingLessonRequired, setIsPolishingLessonRequired] = useState(false);

  const [showIfReplacementService, setShowIfReplacementService] = useState(false);

  const [appealServiceProcesses, setAppealServiceProcesses] = useState([]);
  const [appealServiceProcessLoading, setAppealServiceProcessLoading] = useState(false);
  const [appealServiceProcessError, setAppealServiceProcessError] = useState();

  const [similarLessons, setSimilarLessons] = useState([]);
  const [fetchingSimilarLessons, setFetchingSimilarLessons] = useState(false);

  const currentUserHasLinkedLarkAccount = (currentUser.larkUsers || []).some(
    (lu) =>
      lu.appId === AppMap.SavvyGroup2023.appId ||
      lu.appId === AppMap.SavvyGroup.appId ||
      lu.appId === AppMap.SavvyGroup2025.appId,
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      refreshGradingAssessments({ resetValue: false });
    }, 0);
    return () => clearTimeout(timer);
  }, [refreshGradingAssessments]);

  useEffect(() => {
    if (initialValues?.id && resolvedStudentId && initialValues?.course && initialValues?.startAt) {
      const tz = initialValues.studentTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      const originalTime = dayjs(initialValues.startAt).tz(tz).format('HH:mm');
      const originalTeacherIds = Array.isArray(initialValues.teachers)
        ? initialValues.teachers
        : [initialValues.teachers];

      const payload = {
        studentId: resolvedStudentId,
        course: initialValues.course,
        currentLessonId: initialValues.id,
        startAtTime: originalTime,
        timezone: tz,
        teacherIds: originalTeacherIds.join(','),
      };
      fetchSimilarScheduledLessons(payload);
    }
  }, [
    initialValues?.id,
    resolvedStudentId,
    initialValues?.course,
    initialValues?.startAt,
    initialValues?.teachers,
    initialValues?.studentTimeZone,
  ]);

  const clearStates = () => {
    setCurrentContract();
    setContractData();
    setSelectedAttribute();
    setLessonParent();
    setHasUnfinishedFirstLessonCommunication(false);
    setZoomOptions(zoomDefaultOptions);
    setTeacherOptions([]);
    setGradingAssessmentOptions([]);
    setGradingAssessmentLoading(false);
    gradingFetchIdRef.current += 1;
    lastGradingFetchParamsRef.current = { courseId: null, studentId: null };
    gradingWarningShownRef.current = false;
    formRef.current?.setFieldsValue?.({ assessmentId: undefined });
  };

  useEffect(() => {
    if (lessonParent) {
      const teacherList = lessonParent.teachers || lessonParent.users;
      if (teacherList) {
        const options = teacherList.map((t) => {
          return {
            value: t.id,
            label: `${t.chineseName || t.lastName + t.firstName} [微信：${t.wechatId || '未知'}] ${t.teacherStatus === 'resigned' ? '(已离职)' : ''
              }`,
            disabled: t.disabledInTeacherSelect,
          };
        });
        setTeacherOptions(options);
      }
      if (isAppealCourse(lessonParent) && resolvedStudentId) {
        setAppealServiceProcessLoading(true);
        setAppealServiceProcessError();
        getAppealServiceProcess({
          studentId: resolvedStudentId,
          courseId: lessonParent.id,
          lessonId: initialValues?.id,
        })
          .then((result) => {
            const processes = result?.data || [];
            setAppealServiceProcesses(processes);
            const existingValue = formRef.current?.getFieldValue?.('appealServiceProcessId');
            let defaultValue = existingValue || initialValues?.appealServiceProcessId;
            if (!defaultValue) {
              defaultValue = processes.length === 0 ? 'new' : undefined;
            }
            formRef.current?.setFieldsValue?.({
              appealServiceProcessId: defaultValue,
            });
          })
          .catch((error) => {
            setAppealServiceProcesses([]);
            setAppealServiceProcessError(getErrorMessageFromResponse(error));
          })
          .finally(() => {
            setAppealServiceProcessLoading(false);
          });
      } else {
        setAppealServiceProcesses([]);
        formRef.current?.setFieldsValue?.({
          appealServiceProcessId: undefined,
        });
      }
    } else {
      setTeacherOptions([]);
      setAppealServiceProcesses([]);
      formRef.current?.setFieldsValue?.({
        appealServiceProcessId: undefined,
      });
    }
    return () => {
      setTeacherOptions([]);
      setAppealServiceProcesses([]);
      formRef.current?.setFieldsValue?.({
        appealServiceProcessId: undefined,
      });
    };
  }, [initialValues?.appealServiceProcessId, initialValues?.id, lessonParent, resolvedStudentId]);

  useEffect(() => {
    if (courseId) {
      setCourseLoading(true);
      getCourseById(courseId)
        .then((c) => {
          setCourseData(c);
          setLessonParent(c);
          const courseNo = c.courseNo ? `【${c.courseNo}】 - ` : '';
          formRef?.current?.setFieldsValue({
            course: c.id,
          });
          if (!initialValues?.name) {
            getLessonCount({
              course: c.id,
            }).then((currentCount) => {
              setLessonCount(currentCount);
              formRef?.current?.setFieldsValue({
                name: `${courseNo}${c.name} - Lec ${currentCount + 1}`,
              });
            });
          }
        })
        .catch((e) => {
          message.error('加载课程信息出错');
        })
        .finally(() => {
          setCourseLoading(false);
        });
    } else {
      setCourseData();
    }
    return () => setCourseData();
  }, [courseId]);

  useEffect(() => {
    if (currentContract) {
      setZoomOptions(zoomDefaultOptions);
      setLoading(true);
      getContractById(currentContract)
        .then((c) => {
          setContractData(c);
        })
        .catch((e) => {
          message.error('加载合同信息出错');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setContractData();
      setZoomOptions([
        ...zoomDefaultOptions,
        {
          label: '使用外部链接',
          value: 'external',
        },
      ]);
    }
    return () => setContractData();
  }, [currentContract]);

  const fetchSimilarScheduledLessons = async (payload) => {
    try {
      setFetchingSimilarLessons(true);
      const { studentId, course, currentLessonId, startAtTime, timezone, teacherIds } = payload;
      const lessons = await getSimilarScheduledLessons({
        studentId,
        course,
        currentLessonId,
        startAtTime,
        timezone,
        teacherIds,
        OverDate: true,
      });
      if (lessons?.length) {
        setSimilarLessons(lessons);
      }
    } catch (error) {
      console.error('Failed to get similar lessons for batch update', e);
    } finally {
      setFetchingSimilarLessons(false);
    }
  };

  const buildLessonName = async (lessonParent, type) => {
    const student = contractData?.student;
    if (student) {
      const studentName = `${student.lastName} ${student.firstName} - `;
      if (['置换录播课', '置换直播合同', '无后续服务'].includes(type)) {
        const contractString = `${contractData.organizationContractId || contractData.contractId}`;
        return `【${type}】- ${studentName}${contractString === 'undefined' ? '' : contractString}`;
      } else if (lessonParent) {
        if (lessonParent.courseNo) {
          const courseNo = `【${lessonParent.courseNo}】 - `;
          const lessonCountParams = {
            course: lessonParent.id,
            contract: contractData.id,
          };
          const lessonStudentId = contractData?.student?.id || resolvedStudentId;
          if (lessonStudentId) {
            lessonCountParams.student = lessonStudentId;
          }
          const currentCount = await getLessonCount(lessonCountParams);
          return `${courseNo}${studentName}${lessonParent.name} - ${type === '迟到/旷课扣课时' ? type : `Lec ${currentCount + 1}`
            }`;
        } else {
          return `${studentName}${lessonParent.name}${type === '迟到/旷课扣课时' ? type : ''}`;
        }
      }
    } else if (courseData) {
      // 班课
      const courseNo = courseData.courseNo ? `【${courseData.courseNo}】 - ` : '';
      const currentCount = await getLessonCount({
        course: courseData.id,
      });
      return `${courseNo}${courseData.name} - Lec ${currentCount + 1}`;
    }
    return '';
  };

  const onSubmit = async (values) => {
    if (!timezone) {
      throw new Error('未知时区，请刷新页面后重试。');
    }
    const isUpdate = !!initialValues?.id;
    const data = { ...values };
    data.timezone = timezone;
    if (values.teachers && !Array.isArray(values.teachers)) {
      data.teachers = [values.teachers];
    }
    //如果duration 和 expectWordCount 都没有值，则报错
    if (!values.duration && !values.expectWordCount) {
      message.error('上课时长或预期字数至少要大于0');
      return false;
    }
    if (values.productAttribute && `${values.productAttribute}`.includes('-')) {
      const exchangeKey = values.productAttribute;
      const pair = values.productAttribute.split('-');
      const attrWanted = Number(pair[1]);
      let adjustAmount;
      if (selectedAttribute.chargingUnit === '分钟') {
        adjustAmount = values.duration;
      } else if (selectedAttribute.chargingUnit === '字') {
        adjustAmount = values.expectWordCount;
      } else {
        // 次
        adjustAmount = 1;
      }
      const newProductUsage = getAdjustedProductUsage({
        exchangeKey,
        usageData: contractData.productUsage,
        rules: contractData.products[0].exchangeRules,
        adjustAmount,
      });
      data.newProductUsage = newProductUsage;
      data.productAttribute = attrWanted;
      data.exchangeKey = exchangeKey;
    }
    if (!isAppealCourse(lessonParent)) {
      delete data.appealServiceProcessId;
    }
    if (submitRef.current === 0) {
      const cb = isUpdate ? update : create;

      let createOrUpdateNum = 1;
      let updateIds = [initialValues?.id];

      const originalDate = initialValues?.startAt
        ? dayjs(initialValues.startAt).tz(timezone).format('YYYY-MM-DD')
        : '';
      const newDate = data.startAt ? dayjs(data.startAt).tz(timezone).format('YYYY-MM-DD') : '';
      const originalTime = initialValues?.startAt
        ? dayjs(initialValues.startAt).tz(timezone).format('HH:mm')
        : '';
      const newTime = data.startAt ? dayjs(data.startAt).tz(timezone).format('HH:mm') : '';
      const isOnlyTimeChanged = originalDate === newDate && originalTime !== newTime;
      const isDurationChanged = initialValues.duration !== data.duration;

      if (data.repeatedSchedule && data.repeatedScheduleAmount > 0) {
        createOrUpdateNum += data.repeatedScheduleAmount;
      } else if ((isOnlyTimeChanged || isDurationChanged) && data.similarLessonsToUpdate?.length) {
        createOrUpdateNum += data.similarLessonsToUpdate.length;
        updateIds = updateIds.concat(data.similarLessonsToUpdate);
      }
      let firstLesson;
      // data.startAt 已经是基于所选时区换算后的 UTC 时间（来自 CustomDatePicker）
      // 这里直接从 UTC 起点进行后续计算，避免重复时区换算导致时间偏移
      const startInUTC = dayjs.utc(data.startAt);

      const baseName =
        (data.name && data.name.trim()) || (await buildLessonName(lessonParent, data.type));

      const lecMatch = baseName.match(/^(.*?\bLec\s*)(\d+)(.*)$/i);
      for (let i = 0; i < createOrUpdateNum; i++) {
        try {
          let payload = {};
          let updateOrCreateName;
          if (!isUpdate) {
            payload = { ...data };
            if (data.startAt) {
              payload.startAt = startInUTC
                .clone()
                .add(i, data.repeatedScheduleMethod)
                .toISOString();
            }
            if (data.duration) {
              payload.endAt = startInUTC
                .clone()
                .add(i, data.repeatedScheduleMethod)
                .add(data.duration, 'minutes')
                .toISOString();
            }
            let name = baseName;
            if (i > 0 && lecMatch) {
              const nextNum = Number(lecMatch[2]) + i;
              name = `${lecMatch[1]}${nextNum}${lecMatch[3]}`;
            }
            payload.name = name;
            updateOrCreateName = name;
          } else {
            if (createOrUpdateNum === 1) {
              payload = { ...data };
            }
            let newStartAt = data.startAt;
            updateOrCreateName = data.name;
            if (i > 0) {
              const updateLesson = similarLessons.find(
                (sl) => sl.id === data.similarLessonsToUpdate[i - 1],
              );
              const originalDate = dayjs(updateLesson?.startAt)
                .tz(timezone)
                .format('YYYY-MM-DD');
              // 用 dayjs.tz(字符串, 时区) 按学生时区直接解析「原日期 + 新时间」，
              newStartAt = dayjs
                .tz(`${originalDate} ${newTime}`, timezone)
                .toISOString();
              updateOrCreateName = `${updateLesson?.name}`;
            }
            if (newStartAt) {
              const baseUTC = dayjs.utc(newStartAt);
              payload.startAt = baseUTC.toISOString();
              if (data.duration) {
                payload.endAt = baseUTC
                  .clone()
                  .add(data.duration, 'minutes')
                  .toISOString();
              }
            }
            payload.duration = data.duration;
          }

          message.loading({
            content: `(${i + 1}/${createOrUpdateNum})正在${initialValues?.id ? '更新' : '创建'}: ${i}. ${updateOrCreateName}`,
            key: i,
            duration: 0,
          });
          const response = await cb({
            id: isUpdate ? updateIds[i] : null,
            ...payload,
          });
          if (response.error) {
            throw new Error(`${i}. ${updateOrCreateName}: ${response.message}`);
          }
          if (!response || !response.id) {
            throw new Error(
              `${i}. ${updateOrCreateName}${initialValues?.id ? '更新' : '创建'}失败，请重试。`,
            );
          }

          //Reminder:现在暂时没有给更新的审批流程，也不支持连续创建
          if (
            ['置换录播课', '置换直播合同', '无后续服务'].includes(data.type) &&
            !isUpdate &&
            createOrUpdateNum === 1 &&
            !response.error
          ) {
            if (!currentUserHasLinkedLarkAccount) {
              message.error(
                `请先绑定【SavvyGroup2023】或【SavvyGroup】或 【SavvyGroup2025】的飞书组织,再创建${data.type}课节`,
              );
              return false;
            }
            let approval = null;
            try {
              const payload = {
                duration: data.duration,
                wordCount: data.expectWordCount,
                giftReasonDetails: data.topic,
                giftReasonType: data.type,
                gifter: currentUser.id,
                giveDate: dayjs().tz(timezone).utc().toISOString(),
                giveType: data.type,
                organizationContractId: contractData?.organizationContractId,
                product: contractData?.products?.[0]?.name,
                recordCourse: data.recordCourse || [],
                startAt: dayjs(data.startAt).tz(timezone).utc().toISOString(),
                studentName: `${contractData?.student?.lastName} ${contractData?.student?.firstName}`,
                topic: data.topic,
                type: data.type,
                uploads: data.uploads,
                productAttributeId: data.productAttribute,
                contractId: currentContract,
                lessonId: response.id,
              };

              approval = await larkApprovalForContractReplacement(payload);
            } catch (error) {
              message.error(`发起置换审批失败：${getErrorMessageFromResponse(error)}`);
              return false;
            }

            if (approval?.id) {
              message.success('置换审批已发起，请等待审批结果。');
            }
          }
          if (!firstLesson) {
            firstLesson = response;
          }
          message.success({
            content: `${i + 1}. ${updateOrCreateName}${initialValues?.id ? '更新' : '创建'}成功！`,
            key: i,
            duration: 10,
          });
        } catch (error) {
          message.error({ content: getErrorMessageFromResponse(error), key: i, duration: 5 });
        }
      }
      if (firstLesson) {
        onFinish?.(firstLesson);
      }
      submitRef.current = 0;
      return true;
    }
    return true;
  };

  return (
    <Spin spinning={loading || courseLoading} size="large" tip="努力地加载数据中...">
      {showIfReplacementService && (
        <Alert
          message="换录播课，置换直播课，无后续服务会先发起置换审批，待审批通过后才会有真实上课时长"
          type="info"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}

      {showIfReplacementService && !currentUserHasLinkedLarkAccount && (
        <Alert
          message="请先绑定【思睿贯通2024】或【Savvy】或 【SavvyGroup】的飞书账号，否则无法发起置换审批"
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <ProForm
        formRef={formRef}
        initialValues={{
          headTeacher: !courseId && currentUser.id,
          zoomMeetingType: 'meeting',
          type: 'regular',
          repeatedSchedule: false,
          repeatedScheduleAmount: 0,
          ...initialValues,
        }}
        submitter={{
          submitButtonProps: {
            disabled:
              uploading ||
              potentialPending ||
              potentialConflictLessonsPending ||
              potentialConflictCommunicationPending ||
              (Array.isArray(potentialInterviews) && potentialInterviews.length > 0) ||
              fetchingSimilarLessons,
          },
        }}
        onValuesChange={async (changedValue, values) => {
          if (changedValue.headTeacher) {
            clearStates();
            formRef.current?.resetFields(['contract', 'productAttribute', ...resetFields]);
          }
          if (changedValue.contract) {
            clearStates();
            formRef.current?.resetFields(['productAttribute', ...resetFields]);
            setCurrentContract(changedValue.contract);
          }
          if (changedValue.productAttribute) {
            setTeacherOptions([]);
            formRef.current?.resetFields([...resetFields]);
            let attrWanted = changedValue.productAttribute;
            if (`${changedValue.productAttribute}`.includes('-')) {
              const pair = changedValue.productAttribute.split('-');
              attrWanted = Number(pair[1]);
              formRef?.current?.setFieldsValue({
                repeatedSchedule: false,
                repeatedScheduleAmount: 0,
              });
            }
            const attribute = contractData?.products?.[0]?.productAttributes?.find?.(
              (pa) => pa.id === attrWanted,
            );
            if (attribute) {
              setSelectedAttribute(attribute);
              formRef?.current?.setFieldsValue({
                zoomRequired: attribute.chargingUnit === '分钟' ? 'yes' : 'no',
                zoomLink: null,
              });
            } else {
              setSelectedAttribute();
            }
          }
          if (changedValue.startAt || changedValue.duration) {
            if (initialValues && initialValues.zoom) {
              formRef?.current?.setFieldsValue({
                updateZoom: true,
                zoomRequired: 'yes',
              });
            }
            if (values.startAt && values.duration) {
              formRef?.current?.setFieldsValue({
                endAt: dayjs(values.startAt)
                  .add(values.duration, 'minutes')
                  .utc()
                  .toDate()
                  .toISOString(),
              });
            }

            //检查冲突的课程（老师，学生）都检查
            if (
              changedValue.startAt ||
              changedValue.teachers ||
              changedValue.contract ||
              changedValue.duration
            ) {
              if (values.startAt && values.teachers && values.contract && values.duration) {
                setPotentialConflictLessons({
                  id: initialValues?.id ? initialValues.id : 0,
                  startAt: dayjs(values.startAt).utc().toDate().toISOString(),
                  endAt: dayjs(values.startAt)
                    .add(values.duration, 'minutes')
                    .utc()
                    .toDate()
                    .toISOString(),
                  teachers: Array.isArray(values.teachers) ? values.teachers : [values.teachers],
                  contract: values.contract,
                });

                setPotentialInterviews({
                  interviewTimeStart: [
                    dayjs(values.startAt).toDate(),
                    dayjs(values.startAt).add(values.duration, 'minutes').toDate(),
                  ],
                  interviewerErpIds: values.teachers,
                });

                setPotentialConflictCommunication({
                  teacherId: values.teachers,
                  studentId: contractData?.student?.id,
                  startAt: dayjs(values.startAt).utc().toDate().toISOString(),
                  endAt: dayjs(values.startAt)
                    .add(values.duration, 'minutes')
                    .utc()
                    .toDate()
                    .toISOString(),
                });
              }
            }
          }
          if (changedValue.productService) {
            const selectedService = contractData?.serviceItems?.find?.(
              (s) => s.serviceItem?.id === changedValue.productService,
            )?.serviceItem;
            setLessonParent(selectedService);
            const name = await buildLessonName(selectedService, values.type);
            formRef.current?.setFieldsValue({ name });
            if (selectedService?.teachers?.length === 1) {
              formRef?.current?.setFieldsValue({
                teachers: selectedService?.teachers?.[0]?.id,
              });
            }
          }
          if (changedValue.course) {
            let selectedCourse = courseData?.id
              ? courseData
              : contractData?.courses?.find?.((c) => c.course?.id === changedValue.course);

            if (
              selectedCourse &&
              selectedCourse.educationalResearchTasks &&
              selectedCourse.educationalResearchTasks.length > 0
            ) {
              setHasUnfinishedFirstLessonCommunication(true);
            } else {
              setHasUnfinishedFirstLessonCommunication(false);
            }
            if (selectedCourse.course) {
              selectedCourse = selectedCourse.course;
            }
            setLessonParent(selectedCourse);

            const name = await buildLessonName(selectedCourse, values.type);
            formRef.current?.setFieldsValue({ name });
            if (selectedCourse?.teachers?.length === 1) {
              formRef?.current?.setFieldsValue({
                teachers: selectedCourse?.teachers?.[0]?.id,
              });
            } else {
              formRef?.current?.setFieldsValue({
                teachers: null,
              });
            }
            // 申诉课程不检查评分方案
            if (!isAppealCourse(selectedCourse)) {
              await refreshGradingAssessments();
            }
          }
          if (changedValue.type) {
            formRef.current?.setFieldsValue({
              zoomRequired: changedValue.type === 'regular' ? 'yes' : 'no',
            });
            const name = await buildLessonName(lessonParent, changedValue.type);
            formRef.current?.setFieldsValue({ name });
            if (changedValue.type === '置换录播课') {
              try {
                const courses = await query({ category: '赠课' });
                setRecordCourse(courses);
              } catch (error) {
                setRecordCourse([]);
                message.error('获取录播课课程列表失败，请重试。');
              }
            }
            if (['置换录播课', '置换直播合同', '无后续服务'].includes(changedValue.type)) {
              setShowIfReplacementService(true);
            } else {
              setShowIfReplacementService(false);
            }
          }

          if (changedValue.startAt && timezone) {
            if (dayjs(changedValue.startAt) > dayjs()) {
              isDstDate({
                startDate: new Date().toISOString(),
                endDate: new Date(changedValue.startAt).toISOString(),
                timeZone: timezone,
              }).then((result) => {
                if (result.date) {
                  setDstDatesDisplay([result]);
                } else {
                  setDstDatesDisplay([]);
                }
              });
            }
          }
          //如果选择了重复排课，重复的排课都需要检查是否有夏令时/冬令时转变
          if (changedValue.repeatedScheduleAmount) {
            let createNum = 1 + changedValue.repeatedScheduleAmount;
            //根据重复排课的次数，计算出每次的startAt
            const startInTZ = dayjs(formRef.current.getFieldValue('startAt')).tz(timezone);
            //拿到重复排课的单位
            const repeatedScheduleMethod = formRef.current.getFieldValue('repeatedScheduleMethod');

            const repeat = Number(changedValue.repeatedScheduleAmount) || 0;
            const total = 1 + repeat;

            const occurrences = Array.from({ length: total }, (_, idx) => {
              const s = startInTZ.clone().add(idx, repeatedScheduleMethod);
              const e = s.clone().add(values.duration, 'minute');
              return {
                startAtLocal: s,
                endAtLocal: e,
                startAtISO: s.tz(timezone, true).toISOString(),
                endAtISO: e.tz(timezone, true).toISOString(),
                dstCheckRange: {
                  startDate: (idx === 0
                    ? s.clone().startOf('day')
                    : startInTZ
                      .clone()
                      .add(idx - 1, repeatedScheduleMethod)
                      .startOf('day')
                  ).format('YYYY-MM-DD'),
                  endDate: s.clone().endOf('day').format('YYYY-MM-DD'),
                },
              };
            });

            const dstResults = await Promise.all(
              occurrences.map(({ dstCheckRange }) =>
                isDstDate({
                  startDate: dstCheckRange.startDate,
                  endDate: dstCheckRange.endDate,
                  timeZone: timezone,
                }).catch(() => null),
              ),
            );

            const dstHits = dstResults
              .filter(Boolean)
              .filter((r) => r?.date)
              .reduce((acc, r) => {
                if (!acc.some((x) => x.date === r.date)) acc.push(r);
                return acc;
              }, []);
            setDstDatesDisplay(dstHits);

            setPotentialConflictLessons({
              id: initialValues?.id ?? 0,
              teachers: Array.isArray(values.teachers) ? values.teachers : [values.teachers],
              contract: values.contract,
              isRepeat: true,
              repeatTimeRange: occurrences.map((occ) => ({
                startAt: occ.startAtISO,
                endAt: occ.endAtISO,
              })),
            });

            setPotentialInterviews({
              interviewTimeStart: occurrences.map((occ) => {
                return {
                  start: occ.startAtISO,
                  end: occ.endAtISO,
                };
              }),
              isMultiRange: true,
              interviewerErpIds: values.teachers,
            });

            setPotentialConflictCommunication({
              teacherId: values.teachers,
              studentId: contractData?.student?.id,
              isRepeat: true,
              repeatTimeRange: occurrences.map((occ) => ({
                startAt: occ.startAtISO,
                endAt: occ.endAtISO,
              })),
            });
          }

          if (changedValue.productAttribute || changedValue.course || changedValue.teachers) {
            const { productAttribute, course, teachers } = formRef.current?.getFieldsValue();
            if (!productAttribute) {
              return;
            }
            const attribute = contractData?.products?.[0]?.productAttributes?.find?.(
              (pa) => pa.id === productAttribute,
            );
            // Check if productAttribute is "学术指导1V1"
            const isXueshuzhidao1V1 = attribute.name?.includes('学术指导1V1');
            const isPolishingLesson = attribute.name?.includes('论文润色');

            if (isPolishingLesson) {
              // For "论文润色": default "是"
              formRef?.current?.setFieldsValue({
                isPolishingLesson: true,
              });
              // console.log('🚀 ~ 论文润色');
            } else if (isXueshuzhidao1V1) {
              // query match info
              if (!productAttribute || !teachers || !course) {
                return;
              }
              const courseMatchObj = await getByLesson({
                studentId: contractData?.student?.id,
                teacherId: teachers,
                courseId: course,
              });
              // Check if match types include "论文辅导"
              // Note: API response uses 'courseMatchType' (not 'matchTypes')
              const hasLunwenFudao = courseMatchObj?.courseMatchType?.some?.(
                (matchType) => matchType?.type === '论文辅导',
              );
              if (hasLunwenFudao) {
                // Calculate displayRemaining directly (replicating genTreeStruct logic from AttributeSelect.jsx)
                // Find polishing attribute (论文润色) by chargingUnit === '字'||'次'||'篇' and name includes '润色'
                const product = contractData?.products?.[0];
                const polishingAttr = product?.productAttributes?.find?.(
                  (pa) => ['字', '次', '篇'].includes(pa.chargingUnit) && pa.name?.includes('润色'),
                );

                let displayRemaining = 0;

                if (polishingAttr && contractData) {
                  const productUsage = contractData.productUsage || {};
                  const attributeDetails = product?.attributeDetails || {};

                  // Check if attribute has usage data (lines 21-22 from AttributeSelect.jsx)
                  if (
                    attributeDetails[polishingAttr.id] &&
                    productUsage[product.id]?.[polishingAttr.id]
                  ) {
                    // Lines 31-43 from AttributeSelect.jsx
                    const { exchangeUnitPoint, exchangeUnitQuantity } =
                      productUsage[product.id][polishingAttr.id];
                    const { available: usable } = getAttrUsage(polishingAttr.id, contractData);
                    const totalRemainingPoints = getContractUsablePoints(contractData);

                    let remaining = usable;
                    if (exchangeUnitPoint) {
                      remaining =
                        (Math.max(0, Math.min(remaining, totalRemainingPoints)) /
                          exchangeUnitPoint) *
                        exchangeUnitQuantity;
                    }
                    // Line 65 from AttributeSelect.jsx: For '字', '次', '篇', displayRemaining is the numeric remaining value
                    displayRemaining = remaining;
                  }
                }

                if (displayRemaining > 0) {
                  // 有论文辅导，有可排， default "否"， not required
                  formRef?.current?.setFieldsValue({
                    isPolishingLesson: false,
                  });
                  setIsPolishingLessonRequired(false);
                  // console.log('🚀 ~ 1V1 有论文辅导，有可排');
                } else {
                  //有论文辅导，无可排， default "undefined"， required
                  formRef?.current?.setFieldsValue({
                    isPolishingLesson: undefined,
                  });
                  setIsPolishingLessonRequired(true);
                  // console.log('🚀 ~ 1V1 有论文辅导，无可排');
                }
              } else {
                // 无论文辅导，default "否"， not required
                formRef?.current?.setFieldsValue({
                  isPolishingLesson: false,
                });
                setIsPolishingLessonRequired(false);
                // console.log('🚀 ~ 1V1 无论文辅导');
              }
            } else {
              // For other attributes: default "否"， not required
              formRef?.current?.setFieldsValue({
                isPolishingLesson: false,
              });
              setIsPolishingLessonRequired(false);
              // console.log('🚀 ~ 其他属性');
            }
          }
        }}
        onFinish={onSubmit}
      >
        <Form.Item
          name="headTeacher"
          label="合同班主任"
          hidden={!!courseId || !!initialValues?.id}
          fieldProps={{
            disabled: !!initialValues?.id,
          }}
          rules={[
            {
              required: !courseId,
              message: '请选择合同的班主任',
            },
          ]}
        >
          <HeadTeacherSelect />
        </Form.Item>
        <ProFormDependency name={['headTeacher']}>
          {({ headTeacher }) => {
            if (headTeacher && !courseId) {
              return (
                <Form.Item
                  name="contract"
                  label="排课合同"
                  rules={[
                    {
                      required: true,
                      message: '请选择排课合同',
                    },
                  ]}
                >
                  <ContractSelect
                    headTeacher={headTeacher}
                    student={resolvedStudentId}
                    disabled={!!initialValues?.id}
                    ongoing={true}
                    category="一对一"
                    onSelect={(value, option) => {
                      setTimezone(
                        option.studentTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
                      );
                    }}
                  />
                </Form.Item>
              );
            }
          }}
        </ProFormDependency>
        <ProFormDependency name={['contract']}>
          {({ contract }) => {
            if (!courseId) {
              return (
                <Form.Item
                  name="productAttribute"
                  label="产品属性"
                  rules={[
                    {
                      required: true,
                      message: '请选择产品属性',
                    },
                  ]}
                >
                  <AttributeSelect
                    contract={contractData}
                    disabled={!contract || !!initialValues?.id}
                  />
                </Form.Item>
              );
            }
          }}
        </ProFormDependency>
        <ProFormRadio.Group
          name="type"
          label="课节类型"
          options={[
            {
              label: '常规上课',
              value: 'regular',
            },
            {
              label: '迟到/旷课扣课时',
              value: '迟到/旷课扣课时',
            },
            {
              label: '置换录播课',
              value: '置换录播课',
            },
            {
              label: '置换直播合同',
              value: '置换直播合同',
            },
            {
              label: '无后续服务',
              value: '无后续服务',
            },
          ]}
          hidden={!!courseId}
          rules={[
            {
              required: !courseId,
            },
          ]}
          disabled={!!initialValues?.id}
        />
        <ProFormDependency name={['productAttribute', 'type']}>
          {({ productAttribute, type }) => {
            const hideInForm = ['置换录播课', '置换直播合同', '无后续服务'].includes(type);
            if (hideInForm) return;
            if (productAttribute) {
              let attribute = selectedAttribute;
              if (!attribute) {
                let attrWanted = productAttribute;
                if (`${productAttribute}`.includes('-')) {
                  const pair = productAttribute.split('-');
                  attrWanted = Number(pair[1]);
                }
                attribute = contractData?.products?.[0]?.productAttributes?.find?.(
                  (pa) => pa.id === attrWanted,
                );
                setSelectedAttribute(attribute);
              }
              if (attribute) {
                if (attribute.type === '其它') {
                  const options = contractData?.serviceItems
                    ?.filter?.((s) => s.productAttribute?.id === attribute.id)
                    .map((ps) => {
                      return {
                        value: ps.serviceItem.id,
                        label: `${ps.serviceItem.name} [学术等级：${ps.serviceItem.academicLevel || '未知'
                          }]`,
                      };
                    });
                  return (
                    <ProFormSelect
                      name="productService"
                      label="服务项"
                      required
                      options={options}
                      disabled={!!initialValues?.id}
                    />
                  );
                } else {
                  const courses = contractData?.courses?.filter?.(
                    (c) => c.productAttribute?.id === attribute.id,
                  );
                  let options = [];
                  if (courses && courses.length) {
                    options = courses.map((c) => {
                      return {
                        value: c.course.id,
                        label: `【${c.course.courseNo || '未知课号'}】${c.course.name} [学术等级：${c.course.academicLevel || '未知'
                          }] [课程类型：${c.course.type || '未知'}]`,
                      };
                    });
                  }
                  return (
                    <>
                      {hasUnfinishedFirstLessonCommunication && (
                        <Alert
                          message="暂未完成首课课前沟通"
                          type="warning"
                          showIcon
                          style={{ marginTop: 16 }}
                        />
                      )}
                      <ProFormSelect
                        name="course"
                        label="课程"
                        required
                        options={options}
                        disabled={!!initialValues?.id}
                      />
                    </>
                  );
                }
              }
            } else if (!courseId) {
              return (
                <ProFormSelect
                  name="dummyCourse"
                  label="课程/服务项"
                  required
                  placeholder="请先选择一个产品属性"
                />
              );
            }
          }}
        </ProFormDependency>
        <ProFormSelect
          name="course"
          label="课程名称"
          hidden={!courseId}
          options={[
            {
              value: courseData?.id,
              label: courseData?.name,
            },
          ]}
        />
        {isAppealCourse(lessonParent) && (
          <>
            {appealServiceProcessError ? (
              <Alert
                type="error"
                showIcon
                banner
                style={{ marginBottom: 12 }}
                message="申诉流程信息获取失败"
                description={appealServiceProcessError}
              />
            ) : (
              <Alert
                type={appealServiceProcesses.length ? 'info' : 'warning'}
                showIcon
                banner
                message={
                  appealServiceProcesses.length
                    ? '该课程属于申诉服务，请选择关联的申诉流程'
                    : '该课程属于申诉服务，保存后将自动创建新的申诉流程'
                }
              />
            )}
            <ProFormRadio.Group
              name="appealServiceProcessId"
              label="申诉流程"
              disabled={appealServiceProcessLoading}
              rules={[
                {
                  required: true,
                  message: '请选择一个申诉流程',
                },
              ]}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                {appealServiceProcesses.map((process) => {
                  const status = process.status || 'open';
                  const statusColor = {
                    open: 'blue',
                    success: 'green',
                    fail: 'red',
                    cancelled: 'default',
                  }[status];
                  const statusLabelMap = {
                    open: '进行中',
                    submitted: '已提交',
                    success: '成功',
                    fail: '失败',
                  };
                  const lessons = Array.isArray(process.lessons) ? process.lessons : [];
                  const lastLesson = lessons
                    .slice()
                    .sort((a, b) => dayjs(b.startAt).valueOf() - dayjs(a.startAt).valueOf())?.[0];
                  const createdAtText = process.createdAt
                    ? dayjs(process.createdAt).format('YYYY-MM-DD')
                    : '时间未知';
                  const lastLessonTime = lastLesson?.startAt
                    ? dayjs(lastLesson.startAt).format('YYYY-MM-DD')
                    : '无课节';
                  const lastLessonResult = lastLesson?.appealServiceResult;
                  let lastLessonResultText = '等待中';
                  if (lastLessonResult) {
                    lastLessonResultText = statusLabelMap[lastLessonResult.status] || '未知结果';
                  }
                  return (
                    <Radio
                      key={process.id}
                      value={process.id}
                      style={{ width: '100%' }}
                      disabled={!!process.resolvedAt}
                    >
                      <div style={{ display: 'flex', alignItems: 'left', gap: 4 }}>
                        <span>开始于{createdAtText}</span>
                        <Tag color={statusColor}>流程状态：{statusLabelMap[status]}</Tag>
                        <span>课节数:{lessons.length || 0}</span>
                        <span> </span>
                        <span>最近上课日期:{lastLessonTime}</span>
                        <span> </span>
                        <span>最新结果:{lastLessonResultText}</span>
                      </div>
                    </Radio>
                  );
                })}
                <Radio
                  key="new"
                  value="new"
                  style={{ width: '100%' }}
                // disabled={
                //   appealServiceProcesses.length > 0 && appealServiceProcesses.some((r) => !r.resolvedAt)
                // }
                >
                  + 创建新申诉case
                </Radio>
              </Space>
            </ProFormRadio.Group>
          </>
        )}
        <ProFormDependency name={['course', 'productService', 'type']}>
          {({ course, productService, type }) => {
            if (!lessonParent) {
              if (productService) {
                const selectedService = selectedAttribute?.productServiceItems?.find?.(
                  (ps) => ps.id === productService,
                );
                if (selectedService) {
                  setLessonParent(selectedService);
                }
              } else {
                let selectedCourse = courseData?.id
                  ? courseData
                  : contractData?.courses?.find?.((c) => c.course?.id === course);
                if (selectedCourse?.course) {
                  selectedCourse = selectedCourse.course;
                }
                if (selectedCourse) {
                  setLessonParent(selectedCourse);
                }
              }
            }
            const product = contractData?.products?.[0];
            const consumptionUnit =
              product?.attributeDetails?.[selectedAttribute?.id]?.consumptionUnit;
            const minimumConsumption =
              product?.attributeDetails?.[selectedAttribute?.id]?.minimumConsumption;
            const special = ['置换录播课', '置换直播合同', '无后续服务'].includes(type);
            const wordCountRequired =
              selectedAttribute &&
              (selectedAttribute.chargingUnit === '字' || selectedAttribute.name?.includes('润色'));
            const hasEnoughPoints = (_, value) => {
              if (value && selectedAttribute) {
                if (selectedAttribute.chargingUnit === '字') {
                  if (consumptionUnit && value % consumptionUnit !== 0) {
                    return Promise.reject(`必须为消耗单位(${consumptionUnit}字)的整数倍`);
                  }
                  if (minimumConsumption && value < minimumConsumption) {
                    return Promise.reject(`必须大于单次最低消耗(${minimumConsumption}字)`);
                  }
                  const max = calcAmountAvailable({
                    contract: contractData,
                    productAttribute: formRef?.current?.getFieldValue('productAttribute'),
                    targetAttribute: selectedAttribute,
                    currentLesson: initialValues,
                  });
                  if (value > max) {
                    return Promise.reject('产品属性余额不足');
                  }
                } else {
                  if (
                    selectedAttribute?.chargingUnit === '分钟' &&
                    consumptionUnit &&
                    value % consumptionUnit !== 0
                  ) {
                    return Promise.reject(`必须为消耗单位(${consumptionUnit}分钟)的整数倍`);
                  }
                  const max = calcAmountAvailable({
                    contract: contractData,
                    productAttribute: formRef?.current?.getFieldValue('productAttribute'),
                    targetAttribute: selectedAttribute,
                    currentLesson: initialValues,
                  });
                  if (['次', '篇'].includes(selectedAttribute?.chargingUnit)) {
                    if (max < 1) {
                      return Promise.reject('产品属性余额不足');
                    }
                  } else {
                    if (value > max) {
                      return Promise.reject('产品属性余额不足');
                    }
                  }
                }
              }
              return Promise.resolve();
            };
            return (
              <>
                {/* <ProFormText name="name" label="课节编号（自动生成）" readonly /> */}
                <ProForm.Item name="name" label="课节编号（自动生成）">
                  <LessonNameInput />
                </ProForm.Item>
                <ProFormText
                  name="topic"
                  label={special ? '置换课程名/备注' : '课节主题'}
                  rules={[
                    {
                      required: special,
                    },
                  ]}
                />
                <ProFormSelect
                  name="teachers"
                  label="授课老师"
                  placeholder="请选择授课老师"
                  showSearch={true}
                  options={teacherOptions}
                  disabled={dayjs() > dayjs(initialValues.endAt)}
                  hidden={type !== 'regular'}
                  rules={[
                    {
                      required: type === 'regular',
                    },
                  ]}
                />
                <ProFormDependency name={['productAttribute', 'course', 'teachers']}>
                  {({ productAttribute, course, teachers }) => {
                    if (courseId) return null;
                    const product = contractData?.products?.[0];
                    const isPolishingLesson = product?.productAttributes?.find?.(
                      (pa) => pa.id === productAttribute && pa.name?.includes('论文润色'),
                    );
                    if (isPolishingLesson) {
                      return (
                        <ProFormRadio.Group
                          name="isPolishingLesson"
                          label="是否为润色课"
                          disabled={true}
                          options={[
                            { label: '是', value: true },
                            { label: '否', value: false },
                          ]}
                        />
                      );
                    } else {
                      return (
                        <ProFormRadio.Group
                          name="isPolishingLesson"
                          label="是否为润色课"
                          options={[
                            { label: '是', value: true },
                            { label: '否', value: false },
                          ]}
                          rules={[
                            {
                              required: isPolishingLessonRequired,
                            },
                          ]}
                        />
                      );
                    }
                  }}
                </ProFormDependency>
                <ProFormSelect
                  name="gradingSchemeAssessmentId"
                  label="辅导内容"
                  placeholder={
                    gradingAssessmentLoading
                      ? '辅导内容加载中...'
                      : gradingAssessmentOptions.length
                        ? '请选择辅导内容'
                        : '暂无辅导内容，请先创建辅导内容'
                  }
                  options={gradingAssessmentOptions}
                  loading={gradingAssessmentLoading}
                  allowClear
                  disabled={!gradingAssessmentOptions.length}
                  fieldProps={{
                    showSearch: true,
                    filterOption: (input, option) =>
                      String(option?.label ?? '')
                        .toLowerCase()
                        .includes(String(input ?? '').toLowerCase()),
                  }}
                />
                {dstDatesDisplay && dstDatesDisplay.length > 0 && (
                  <Alert
                    message={`选择的时区将在${dayjs(dstDatesDisplay[0].date).format(
                      'YYYY-MM-DD HH:mm',
                    )}（北京时间：${dayjs
                      .tz(dstDatesDisplay[0].date, dstDatesDisplay[0].timeZone)
                      .utcOffset(
                        dayjs.tz(dstDatesDisplay[0].date, dstDatesDisplay[0].timeZone).utcOffset(),
                      )
                      .tz('Asia/Shanghai')
                      .format('YYYY-MM-DD HH:mm')}
                    ）变为${dstDatesDisplay[0].status},请注意排课时间`}
                    banner
                    showIcon
                    closable
                    onClose={() => setDstDatesDisplay()}
                  />
                )}
                <Form.Item
                  name="startAt"
                  label={special ? '置换/消耗时间' : '上课时间'}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                  tooltip="如果学生档案中有时区信息，将会自动使用学生的时区。"
                >
                  <CustomDatePicker
                    // disabled={timeChangeDisabled({
                    //   currentUser,
                    //   permissions: permissions.lesson,
                    //   editing: !!initialValues?.id,
                    //   type: 'startAt',
                    //   values: initialValues,
                    // })}
                    datepickerFieldProps={{
                      minuteStep: 5,
                    }}
                    onTimezoneChange={(tz) => {
                      setTimezone(tz);
                    }}
                    timeZone={timezone}
                  />
                </Form.Item>
                <ProFormGroup>
                  <Form.Item
                    name="duration"
                    label={type === 'regular' ? '预排课时' : '需消耗课时'}
                    rules={
                      !wordCountRequired
                        ? [
                          {
                            required: true,
                          },
                          {
                            validator: hasEnoughPoints,
                          },
                        ]
                        : []
                    }
                  >
                    <RawDurationView
                      disabled={timeChangeDisabled({
                        currentUser,
                        permissions: permissions.lesson,
                        editing: !!initialValues?.id,
                        type: 'duration',
                        values: initialValues,
                      })}
                      step={
                        selectedAttribute?.chargingUnit === '分钟' && consumptionUnit
                          ? consumptionUnit
                          : 1
                      }
                    />
                  </Form.Item>

                  <ProFormDigit
                    width="sm"
                    name="expectWordCount"
                    label="预计润色字数"
                    placeholder="请输入预计润色字数"
                    hidden={!!courseId}
                    disabled={wordChangeDisabled({
                      currentUser,
                      permissions: permissions.lesson,
                      editing: !!initialValues?.id,
                      type: 'expectWordCount',
                      values: initialValues,
                    })}
                    fieldProps={{
                      step:
                        selectedAttribute?.chargingUnit === '字' && consumptionUnit
                          ? consumptionUnit
                          : 1,
                    }}
                    rules={
                      wordCountRequired
                        ? [
                          {
                            required: true,
                          },
                          {
                            validator: hasEnoughPoints,
                          },
                        ]
                        : []
                    }
                  />
                </ProFormGroup>
                {potentialConflictLessons.conflict && (
                  <div
                    style={{
                      fontSize: '12px',
                    }}
                  >
                    <div
                      style={{
                        color: 'red',
                      }}
                    >
                      可能有冲突的时间(修改时间才能提交)：
                    </div>
                    <div>
                      {potentialConflictLessons.mayConflictStudentLessons &&
                        potentialConflictLessons.mayConflictStudentLessons.length > 0 && (
                          <span>
                            学生：
                            {potentialConflictLessons.mayConflictStudentLessons.map((lesson) => {
                              return (
                                <Tag key={lesson.id}>
                                  {`${dayjs(lesson.startAt).tz(timezone).format('YYYY-MM-DD HH:mm')} -
                                ${dayjs(lesson.endAt).tz(timezone).format('YYYY-MM-DD HH:mm')} (${cn[timezone]})`}
                                </Tag>
                              );
                            })}
                          </span>
                        )}
                    </div>
                    <div>
                      {potentialConflictLessons.mayConflictTeacherLessons &&
                        potentialConflictLessons.mayConflictTeacherLessons.length > 0 && (
                          <span>
                            老师：
                            {potentialConflictLessons.mayConflictTeacherLessons.map((lesson) => {
                              return (
                                <Tag key={lesson.id}>
                                  {`${dayjs(lesson.startAt).tz(timezone).format('YYYY-MM-DD HH:mm')} -
                                ${dayjs(lesson.endAt).tz(timezone).format('YYYY-MM-DD HH:mm')} (${cn[timezone]})`}
                                </Tag>
                              );
                            })}
                          </span>
                        )}
                    </div>
                  </div>
                )}
                {/* 可能冲突的老师面试时间 */}
                {potentialInterviews && potentialInterviews.length > 0 && (
                  <div>
                    <div
                      style={{
                        color: 'red',
                        fontSize: '12px',
                      }}
                    >
                      与老师面试时间冲突(修改时间才能提交)：
                    </div>
                    <div>
                      {potentialInterviews.map((interview) => {
                        const interviewTz = interview.timezone || 'Asia/Shanghai';
                        const startInInterviewTz = dayjs
                          .utc(interview.interviewTimeStart)
                          .tz(interviewTz);
                        const endInInterviewTz = startInInterviewTz.add(
                          interview.duration,
                          'minutes',
                        );

                        // 2. 转成 lesson 选的时区来显示
                        return (
                          <Tag key={interview.id}>
                            {`${startInInterviewTz.tz(timezone).format('YYYY-MM-DD HH:mm')} -
          ${endInInterviewTz.tz(timezone).format('YYYY-MM-DD HH:mm')} (${cn[timezone]})`}
                          </Tag>
                        );
                      })}
                    </div>
                  </div>
                )}
                {potentialConflictCommunication.conflict && (
                  <div style={{ fontSize: '12px', marginBottom: 16 }}>
                    <div style={{ color: 'red', fontSize: '12px', marginBottom: 8 }}>
                      可能的课前沟通时间冲突（请修改时间后提交）：
                    </div>
                    {potentialConflictCommunication.mayConflictStudentCommunications &&
                      potentialConflictCommunication.mayConflictStudentCommunications.length >
                      0 && (
                        <div>
                          <span>学生：</span>
                          {potentialConflictCommunication.mayConflictStudentCommunications.map(
                            (communication) => (
                              <Tag key={communication.id}>
                                {`${dayjs(communication.startAt)
                                  .tz(timezone)
                                  .format('YYYY-MM-DD HH:mm')} - ${dayjs(communication.endAt)
                                    .tz(timezone)
                                    .format('YYYY-MM-DD HH:mm')} (${cn[timezone]})`}
                              </Tag>
                            ),
                          )}
                        </div>
                      )}
                    {potentialConflictCommunication.mayConflictTeacherCommunications &&
                      potentialConflictCommunication.mayConflictTeacherCommunications.length >
                      0 && (
                        <div>
                          <span>教师：</span>
                          {potentialConflictCommunication.mayConflictTeacherCommunications.map(
                            (communication) => (
                              <Tag key={communication.id}>
                                {`${dayjs(communication.startAt)
                                  .tz(timezone)
                                  .format('YYYY-MM-DD HH:mm')} - ${dayjs(communication.endAt)
                                    .tz(timezone)
                                    .format('YYYY-MM-DD HH:mm')} (${cn[timezone]})`}
                              </Tag>
                            ),
                          )}
                        </div>
                      )}
                  </div>
                )}
                <ProFormDateTimePicker hidden name="endAt" label="结束时间" />
                <ProFormRadio.Group
                  name="updateZoom"
                  label="需要更新直播间"
                  hidden={!initialValues?.id}
                  disabled={initialValues?.startAt && new Date(initialValues.startAt) < new Date()}
                  rules={[{ required: !!initialValues?.id }]}
                  options={[
                    {
                      label: '是',
                      value: true,
                    },
                    {
                      label: '否',
                      value: false,
                    },
                  ]}
                />
                <ProFormDependency name={['updateZoom', 'type']}>
                  {({ updateZoom, type }) => {
                    const editing = !!initialValues?.id;
                    return (
                      <ProFormRadio.Group
                        name="zoomRequired"
                        label="直播间设置"
                        options={zoomOptions}
                        rules={[
                          { required: (!editing && type === 'regular') || (editing && updateZoom) },
                        ]}
                        hidden={editing && !updateZoom}
                        disabled={type !== 'regular'}
                      />
                    );
                  }}
                </ProFormDependency>
                <ProFormDependency name={['zoomRequired']}>
                  {({ zoomRequired }) => {
                    if (zoomRequired === 'external') {
                      return <ProFormText name="zoomLink" label="外部链接" required />;
                    }
                  }}
                </ProFormDependency>
                <ProFormDependency name={['zoomRequired']}>
                  {({ zoomRequired }) => {
                    const category = courseData ? courseData.category : '';
                    if (zoomRequired === 'yes' && ['赠课', '班课'].includes(category)) {
                      return (
                        <ProFormRadio.Group
                          name="zoomMeetingType"
                          label="选择教室类型"
                          options={zoomDefaultOptionsForBanKe}
                          value={'meeting'}
                          rules={[{ required: true }]}
                        />
                      );
                    }
                  }}
                </ProFormDependency>
                <ProFormGroup>
                  <ProFormDependency name={['productAttribute', 'type']}>
                    {({ productAttribute, type }) => {
                      return (
                        <ProFormRadio.Group
                          name="repeatedSchedule"
                          label="是否重复排课"
                          hidden={!!initialValues?.id || !!courseId}
                          disabled={
                            (productAttribute && String(productAttribute).includes('-')) ||
                            ['置换录播课', '置换直播合同', '无后续服务'].includes(type)
                          }
                          help={
                            productAttribute && String(productAttribute).includes('-')
                              ? '不支持排课时批量兑换'
                              : ''
                          }
                          options={[
                            {
                              label: '是',
                              value: true,
                            },
                            {
                              label: '否',
                              value: false,
                            },
                          ]}
                        />
                      );
                    }}
                  </ProFormDependency>
                  <ProFormDependency name={['repeatedSchedule']}>
                    {({ repeatedSchedule }) => {
                      if (repeatedSchedule) {
                        return (
                          <ProFormRadio.Group
                            name="repeatedScheduleMethod"
                            label="重复排课频率"
                            options={repeatedScheduleOptions}
                            rules={[{ required: repeatedSchedule }]}
                            hidden={initialValues?.id}
                          />
                        );
                      }
                    }}
                  </ProFormDependency>
                  <ProFormDependency
                    name={[
                      'repeatedSchedule',
                      'duration',
                      'expectWordCount',
                      'repeatedScheduleAmount',
                    ]}
                  >
                    {({ repeatedSchedule, duration, expectWordCount, repeatedScheduleAmount }) => {
                      if (repeatedSchedule) {
                        return (
                          <ProFormDigit
                            width="xs"
                            name="repeatedScheduleAmount"
                            label="重复次数"
                            placeholder="请输入重复次数"
                            // help={`共创建${1 + repeatedScheduleAmount ?? 0}节课`}
                            help={`共创建${1 + (Number(repeatedScheduleAmount) || 0)}节课`}
                            rules={[
                              { required: true },
                              {
                                validator: async (_, value) => {
                                  if (value && selectedAttribute) {
                                    let usage = value + 1;
                                    if (selectedAttribute.chargingUnit === '字') {
                                      usage = (value + 1) * expectWordCount;
                                    } else if (selectedAttribute.chargingUnit === '分钟') {
                                      usage = (value + 1) * duration;
                                    }
                                    return hasEnoughPoints(null, usage);
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                            fieldProps={{ precision: 0 }}
                            hidden={initialValues?.id}
                          />
                        );
                      }
                    }}
                  </ProFormDependency>
                </ProFormGroup>
                {/* 如果是置换录播课则多录播课选择和图片上传 */}
                <ProFormDependency name={['type']}>
                  {({ type }) => {
                    if (type === '置换录播课') {
                      return (
                        <>
                          {/* 录播课 */}
                          <ProForm.Item
                            name="recordCourse"
                            label="录播课"
                            rules={[
                              {
                                required: true,
                              },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              showSearch
                              allowClear
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {recordCourse?.map((c) => {
                                return (
                                  <Option key={c?.id} value={c?.id}>
                                    {c?.name}
                                  </Option>
                                );
                              })}
                            </Select>
                          </ProForm.Item>
                          {/* 图片上传 */}
                          <ProForm.Item
                            name="uploads"
                            label="图片上传"
                            rules={[{ required: true, message: '请上传相关图片' }]}
                          >
                            <FileUpload
                              maxCount={10}
                              beforeUpload={(file) => {
                                const isImage =
                                  file.type === 'image/jpeg' ||
                                  file.type === 'image/jpg' ||
                                  file.type === 'image/png';
                                if (!isImage) {
                                  message.error(`请上传图片,${file.name} 不是图片文件`);
                                  return Upload.LIST_IGNORE;
                                }
                                return isImage;
                              }}
                              onUploadingChange={(isUploading) => {
                                setUploading(isUploading);
                              }}
                              accept=".jpg,.jpeg,.png"
                            />
                          </ProForm.Item>
                        </>
                      );
                    }
                  }}
                </ProFormDependency>
              </>
            );
          }}
        </ProFormDependency>
        <ProFormDependency name={['startAt', 'duration']}>
          {({ startAt, duration }) => {
            if (
              !initialValues?.id ||
              similarLessons.length === 0 ||
              !startAt ||
              !initialValues.startAt ||
              duration == null
            )
              return null;
            const originalDate = dayjs(initialValues.startAt).tz(timezone).format('YYYY-MM-DD');
            const newDate = dayjs(startAt).tz(timezone).format('YYYY-MM-DD');
            const originalTime = dayjs(initialValues.startAt).tz(timezone).format('HH:mm');
            const newTime = dayjs(startAt).tz(timezone).format('HH:mm');

            const isOnlyTimeChanged = originalDate === newDate && originalTime !== newTime;
            const isOnlyDurationChanged = initialValues.duration !== duration;
            if (!isOnlyTimeChanged && !isOnlyDurationChanged) return null;

            return (
              <Alert
                description={
                  <ProFormCheckbox.Group
                    name="similarLessonsToUpdate"
                    label={`发现 ${similarLessons.length} 节同系列排课，勾选同步修改这些课节(只支持同步修改上课时间和预排课时)：`}
                    options={similarLessons.map((sl) => ({
                      label: `${sl.name} (${dayjs(sl.startAt).tz(timezone).format('YYYY-MM-DD HH:mm')} - ${dayjs(sl.endAt).tz(timezone).format('HH:mm')})`,
                      value: sl.id,
                    }))}
                  />
                }
                type="info"
                style={{ marginBottom: 24 }}
              />
            );
          }}
        </ProFormDependency>
      </ProForm>
    </Spin>
  );
};
export default CreateForm;
